import generateFileTypeErrorMessage from "@/utils/generate-file-type-error-message";

export const ERROR_MESSAGE_COPIES = {
    type: "Please enter a valid {{0}}.",
	mandatory: {
		string: "This field is required. Please provide a brief description.",
		date: "This field is required. Please provide a valid date and time.",
		number: "This field is required. Please provide a number.",
		enum: "This field is required. Please select the correct option.",
        conditional: "This field is required, because {{0}} is {{1}}set to {{2}}. Please provide a value."
	},
	payload: {
		size: "Payload file exceeds size limit. Please upload a file that has a max size of {{0}}MB.",
		fileType: generateFileTypeErrorMessage(['.json', '.csv']),
		structure: "The data structure of the file is incorrect. Please upload a file with a structure that aligns with <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{0}}\">API document</a>.",
	},
	attachment: {
		fileType: "Invalid attachment file type. Please upload file in these formats only: .pdf, .doc, .docx, .tt, .png, .jpg, .jpeg, .tif, .tiff, .dcm, .gif, .bmp, .dicom, .heic, .ppt, .pptx, .xls, .xlsx, .xml, .eml, .msg.",
		size: "Attachment files exceed size limit. Total size of attachments cannot exceed {{0}}MB.",
		missing: "File attachment required. Please upload a file.",
		pathMismatch: "File attachment path mismatch. Please upload a file with a name that matches the file name indicated in your csv/json.",
	},
	// pattern
	pattern: {
		specialCharacters: "Special character(s) not allowed: !, @, #, $, %, ^, &, *, (, ), _, +, =, {, }, [, ], |, \, :, ;, \", ', <, >, ., /, ~, `.",
		onlyValue: "Please provide the value in the format {{0}}.",
		valueWithMinMaxLength: "Value must be between {{0}} and {{1}} characters. Please use the format: {{2}}.",
		exactNumberDigits: "The value must contain exactly {{0}} numeric digits."
	},
	length: {
		minMaxCharactersLength: "The field must be between {{0}} and {{1}} alphanumeric characters.",
		maxValue: "The number cannot exceed {{0}}.",
        minValue: "The number must be greater than {{0}}.",
        maxLength: "The value must not exceed {{0}} characters.",
		minLength: "The value must have at least {{0}} characters.",
        maxDecimalPlacesLength: "The value entered must not exceed {{0}} decimal places.",
		minMaxNumberValue: "The value must be between {{0}} and {{1}}",
		exactCharactersLength: "The value must contain exactly {{0}} characters."
	},
	format: {
		date: "Invalid date format. Please provide the date in the format {{0}} (e.g., {{1}}).",
		"date-time": "Invalid date and time format. Please provide the date and time in the format {{0}} (e.g., {{1}}).",
	},
	business: {
        sumEquals: "The sum of the values must equal {{0}}.",
        sameDay: "{{0}} is not the same day as {{1}}.",
        maxTotalDuration: "Total duration {{0}} hours exceeds maximum allowed {{1}} hours.",
        dateCompare: "{{0}} is not the {{1}} as {{2}}.",
		masterDataValidation: "Value \"{{0}}\" is not found in pre-defined master list."
    },
	// enum
	enum: "Please input one of the valid options: {{0}}",
	// generic
	generic: "Please provide a valid value."
};

export const ERROR_KEYWORDS = {
    REQUIRED: 'required',
    TYPE: 'type',
    MIN_LENGTH: 'minLength',
    ADDITIONAL_PROPERTIES: 'additionalProperties',
    FORMAT: 'format',
    ENUM: 'enum',
    MAX_LENGTH: 'maxLength',
    PATTERN: 'pattern',
    MAXIMUM: 'maximum',
    MINIMUM: 'minimum',
    MULTIPLE_OF: 'multipleOf',
	SUM_EQUALS: 'sumEquals',
    DATE_COMPARE: 'dateCompare',
    SAME_DAY: 'sameDay',
    MAX_TOTAL_DURATION: 'maxTotalDuration',
	MASTER_DATA_VALIDATION: 'masterDataValidation',
};

export default ERROR_MESSAGE_COPIES;

export const ERROR_MESSAGE_TIERS = {
    MANDATORY: 30,
    OTHER: 60,
};
